import taskStack from './taskStack'
import history from './history'
import supreme from "../supreme";
import {type} from '../util/util';
export default {
  // 栈里新增一个任务
  add(params){
    var task = taskStack.add(params);
    this.asyncTaskStack(taskStack.getStack());
    return task;
  },
  addTask(task){
    var task = taskStack.addTask(task);
    this.asyncTaskStack(taskStack.getStack());
    return task;
  },
  //出栈一个任务
  pop(){
    this.asyncTaskStack();
    var task =taskStack.pop();
    return task;
  },
  //填充vue 对象到task栈中
  fillVueComponentToTask(gid,vue){
    // 把task 先同步到taskStack 中
    var task = taskStack.fillVueComponentToTask(vue,supreme.getQueryObject());
    // 页面被重新加载的情况
    if(taskStack.getStack().length==1){
      this.asyncTaskStack(task)
    }
    return task;
  },
  // 判断浏览器是前进还是回退
  getBrowserDirection(){

    //direction : back forward
    var isExist=false;
    var gid = supreme.getQueryString("url_gid");
    var stack=this.getTaskStack();
    for(let task of stack){
      if(task.gid==gid){
        isExist=true;
      }
    }
    if(stack.length==1){
      isExist=true;
    }

    return isExist?"back":"forward";

  },
  // 根据名称指定回退到某一个task
  backToTaskByName(name){
    return taskStack.backToTaskByName(name);
  },
  // 根据步数回退到某一个task 参数必须是正整数
  backToTaskByStep(step){
    return taskStack.backToTaskByStep(step);
  },
  // 触发任务栈中vue 组件的回退功能
  triggerVueComBack() {
    var task = this.getCurrentTask();
    if(task){
      task.back();
    }else{
      //todo
    }
  },
  // 触发任务栈中vue 组件appear
  triggerVueComAppear(info){
    var task = this.getCurrentTask();
    if(task){
      if(type.isFunction(task.appear)){
        task.appear(info);
      }
    }else{
      //todo
    }
  },
  // 触发任务栈中vue 组件 networkChange
  triggerVueNetworkChange(status){
    var task = this.getCurrentTask();
    if(task){
      if(type.isFunction(task.networkChange)){
        task.networkChange(status)
      }
    }else{
      // todo
    }

  },

  // 获取栈
  getTaskStack(){
    return taskStack.getStack();
  },
  //判断任务栈是否为空
  isEmpty(){
    return taskStack.isEmpty();
  },
  getCurrentTask(){
    return this.getLastTask();
  },
  getLastTask(){
    return taskStack.getLastTask();
  },
  //获取整个task栈
  getTaskStack(){
    return taskStack.getStack();
  },

  clear(){
    taskStack.clear();
  },
  /**
   * @param currentTask 当前 task
   * */
  asyncTaskStack(currentTask){

    var currentTaskArray = taskStack.getStack();
    var hisTaskArray = history.getLocalTaskHistory();

    if(currentTaskArray.length==1&&hisTaskArray.length>=2){
      this.restoreHistoryToTaskStack(currentTask);
    }
    history.asyncTaskStack(taskStack.getStack())

  },
  /**
   * @param currentTask 当前 task
   * */
  // 恢复本地数据到task 栈中
  restoreHistoryToTaskStack(currentTask){
    // 处理用户当浏览器直接输入地址导致非正常路径的刷新对页面task路径破坏的修复
    var task = this.getLastTask();
    var historyTaskStack = history.getLocalTaskHistory();
    var index=0;
    for(var i =0;i<historyTaskStack.length;i++){
      if(historyTaskStack[i].pathName.replace("/","")==task.pathName.replace("/","")){
        index=i;
        break;
      }
    }
    var resultTaskStack;
    var regainView;
    try{
      regainView =(supreme.getQueryString("regainView")=="true")
    }catch(ex){
      regainView=false;
    }
    // 如果用户设置regainView 恢复浏览页面可以把当前浏览
    // 当index !0  当前task 已经被包含在历史中
    if(index!=0){

      resultTaskStack = historyTaskStack.slice(0,index+1);
    }else{
      if(regainView){
        historyTaskStack.push(task);
        resultTaskStack = historyTaskStack
      }else{
        resultTaskStack = [];
      }

    }

    taskStack.setStack(resultTaskStack);
  },
  // 获取方向
  getDirection(){
    //direction : back forward
    var gid = supreme.getQueryString("url_gid");
    var tkStack=taskStack.taskStack;
    var abandonTaskStack=taskStack.abandonTask;
    var direction="forward";
    for(var i=0;i<tkStack.length;i++){
      var task = tkStack[i];
      if(task.gid==gid){
        direction="back";
      }
    }

    return direction;
  },

}
